<article *ngIf="statusCode == 0" class="featured">
    <a [routerLink]="'/news/' + registers[0].url_amigavel" class="featured-link">
        <div class="featured-image">
            <img [src]="registers[0].images[0]?.slider" [alt]="registers[0].title" />
        </div>
        <div class="featured-content">
            <h2 class="featured-title">{{ registers[0].title }}</h2>
            <span class="featured-date">{{ registers[0].dt_post }} </span>
            <p class="featured-summary" [innerHTML]="registers[0].text_summary"></p>
        </div>
    </a>
</article>
<h2 class="not-found" *ngIf="statusCode > 0">
    Ops!
    <br />
    <span>{{ message }}</span>
</h2>
